import { createSelector } from 'reselect';
import { MODAL_TYPES } from 'a/components/ModalSystem/constants';

export const getOpenModals = state => state.modalSystem.openModals;

export const getWaitingListModals = state => state.modalSystem.waitingListModals;

export const getAreThereModalsWaitingToBeOpen = createSelector(
  [getWaitingListModals],
  waitingListModals => waitingListModals.length > 0,
);

export const getFirstOpenModal = createSelector(
  [getOpenModals],
  (openModals) => {
    const firstModal = openModals.length > 0 ? openModals[0] : {};
    return firstModal;
  },
);

export const getOpenModalType = createSelector(
  [getFirstOpenModal],
  firstModal => firstModal.modalType,
);

export const getOpenModalConfig = createSelector(
  [getFirstOpenModal],
  firstModal => firstModal.config,
);

export const getIsLogoutModalOpen = createSelector(
  [getOpenModalType],
  modalType => modalType === MODAL_TYPES.LOGOUT,
);

export const getIsSessionTimeoutModalOpen = createSelector(
  [getOpenModalType],
  modalType => modalType === MODAL_TYPES.SESSION_TIMEOUT,
);

export const getIsMultipleSessionsModalOpen = createSelector(
  [getOpenModalType],
  modalType => modalType === MODAL_TYPES.MULTIPLE_SESSIONS,
);

export const getIsModalOpen = createSelector(
  [getOpenModals],
  openModals => openModals.length > 0,
);

export const getIsThisTypeOfModalOpen = (state, modalType) => {
  const openModals = getOpenModals(state);
  const isOpen = openModals.filter(om => om.modalType === modalType).length > 0;
  return isOpen;
};
